/** Web/node have no Android system back dispatcher. */
export function subscribeToAndroidEdgeBack(
  _listener: (edge: "left" | "right") => void,
): () => void {
  return () => {};
}
